define([
	"csi/action/Excel",
	"csi/def/ActionFactory",
	"csi/locale",
	"csi/view/ToolbarPlugin"
], function(Excel,ActionFactory,locale,ToolbarPlugin) {

	return ActionFactory.declare("SlicerExcel", Excel, {
		bMaxLimit: false,
		
		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			this.inherited(arguments);
			
			this.m_tooltip = locale.resource("TableExcel_TT");		
		}
	});
});